<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <graph-tool-bar :dateRangeMenu="false"></graph-tool-bar>
        </md-card-header>

        <md-card-content>
          <highcharts class="charts" :options="chartOptions" ref="areaChart"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import graphToolBar from "@/components/GraphToolBar";
import snackBar from "@/components/SnackBar";
import areaChartOptions from "@/config/charts/line";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";

export default {
  components: {
    "graph-tool-bar": graphToolBar,
    "snack-bar": snackBar
  },
  data() {
    return {
      chartOptions: null,
      selectedPhaseLocal: null,
      phases: ["L1", "L2", "L3"]
    };
  },
  computed: {
    selectedPhase() {
      return this.$store.getters.getSettings.phase;
    },
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    },
    WSmessage() {
      return this.$store.getters.getDataMessage;
    }
  },
  watch: {
    selectedDevice: function(newDevice, oldDevice) {
      if (newDevice.mac !== oldDevice.mac) {
        const { chart } = this.$refs.areaChart;
        while (chart.series.length > 0) {
          chart.series[0].remove(false, false);
        }
        this.setSeries();
      }
    },
    WSmessage: function(payload, oldPayload) {
      if (payload) {
        const { chart } = this.$refs.areaChart;

        let chartDataLength = 0;
        const seriesLength = chart.series.length;
        for (let i = 0; i < seriesLength; i++) {
          if (chart.series[i].visible === true) {
            chartDataLength = chart.series[i].data.length;
            break;
          }
        }

        let shift = chartDataLength > 20;

        let sumValue = 0;
        for (let i = 0; i < this.selectedDevice.phase_use; i++) {
          chart.series[i].addPoint(
            [payload.ts * 1000, payload.PF[this.phases[i]]],
            false,
            shift,
            false
          );
          sumValue += payload.PF[this.phases[i]];
        }
        if (this.selectedDevice.phase_use > 1) {
          chart.series[this.selectedDevice.phase_use].addPoint(
            [payload.ts * 1000, sumValue / this.selectedDevice.phase_use],
            false,
            shift,
            false
          );
        }

        chart.redraw();
      } else {
        this.$refs.snackbar.notify(this.$lang.messages.api_communication_error);
      }
    }
  },
  created() {
    this.chartOptions = areaChartOptions;
    this.chartOptions.title.text = "Power factor";
    this.chartOptions.yAxis.labels.format = "{value} °";
    this.chartOptions.tooltip.pointFormat =
      "<span style='color:{point.color}'>●</span> {series.name}: <b>{point.y} °</b><br/>";
    this.setSeries();
  },
  methods: {
    setSeries() {
      const onPhaseSelect = (phase, visibility) => {
        this.selectedPhaseLocal = this.selectedPhase;
        this.selectedPhaseLocal[phase] = !visibility;
        this.$store.commit("setSelectedPhase", this.selectedPhaseLocal);
      };

      this.chartOptions.series = [];

      for (let i = 0; i < this.selectedDevice.phase_use; i++) {
        this.chartOptions.series.push({
          name: this.$lang.charts.phase + " " + this.phases[i],
          type: "spline",
          visible: this.selectedPhase[this.phases[i]],
          events: {
            legendItemClick: function(event) {
              onPhaseSelect(this.phases[i], event.target.visible);
            }.bind(this)
          },
          data: []
        });
      }

      if (this.selectedDevice.phase_use > 1) {
        this.chartOptions.series.push({
          name: this.$lang.charts.average,
          type: "spline",
          visible: this.selectedPhase.AVG,
          events: {
            legendItemClick: function(event) {
              onPhaseSelect("AVG", event.target.visible);
            }.bind(this)
          },
          data: []
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.md-layout {
  margin-top: -29px;
}
</style>
